import React from "react";
import { Box } from "@mui/material";
import { MyDocumentsDataPanel } from "my-documents/components";
import { MyHrContractCard } from "my-hr/components";
import { OcPageNameTitle, OcPageTransition } from "oc/components";

type MyDocumentsUserFilesPageViewProps = {
  t: (key: string) => string;
  isMobile: boolean;
  contractData: any;
  employeeData: any;
  isUploader: boolean;
};

export const MyDocumentsUserFilesPageView = React.memo(
  ({
    t,
    isMobile,
    contractData,
    employeeData,
    isUploader,
  }: MyDocumentsUserFilesPageViewProps) => (
    <OcPageTransition>
      <OcPageNameTitle title={t("MY_DOCUMENTS_USER_FILES_PAGE_TITLE")} goBack />
      <Box padding={isMobile ? "0 0 16px" : "0 16px 16px"}>
        <MyHrContractCard employee={employeeData} contract={contractData} />
        <Box mt={2} />
        <MyDocumentsDataPanel
          isUploader={isUploader}
          contractCode={contractData?.code}
        />
        <Box mt={2} />
      </Box>
    </OcPageTransition>
  ),
);

MyDocumentsUserFilesPageView.displayName = "MyDocumentsUserFilesPageView";

export default MyDocumentsUserFilesPageView;
